// src/config/index.js
export const API_BASE_URL = "https://api.bluedartexpress.ae";
export const API_TIMEOUT = 10000; // in milliseconds
export const SUPPORT_EMAIL = "info@bluedartexpress.ae"; // Support email address
export const SUPPORT_PHONE = "+971588662749"; // Support phone number
export const SUPPORT_HOURS = "Open 24/7"; // Support business hours
export const COMPANY_NAME = "Blue Dart Express";    // Company name for branding  